import tokens from './tokens/tokensToTheme.json';

import components from './Components/components.theme';
import { BREAKPOINTS } from './types/bitkit';

export const breakpoints = {
  [BREAKPOINTS.MOBILE]: '0rem',
  [BREAKPOINTS.TABLET]: '53rem', // 848px
  [BREAKPOINTS.DESKTOP]: '80rem', // 1280px
  [BREAKPOINTS.WIDEDESKTOP]: '101rem', // 1616px
};

const theme = {
  ...tokens,
  breakpoints,
  components,
  config: {
    cssVarPrefix: '',
  },
  styles: {
    global: {
      '*:focus-visible': {
        boxShadow: 'outline',
        outline: 'none',
      },
      a: {
        textDecoration: 'none',
      },
      body: {
        color: 'text.body',
        fontFamily: 'body',
        fontSize: '3',
        lineHeight: 'size-3',
      },
      hr: {
        borderTopWidth: 0,
      },
      'pre, code, kbd, samp': {
        fontFamily: 'mono',
      },
    },
  },
};

export default theme;
